<template>
  <div>
    <v-container>
      <v-layout class="mb-3" wrap>
        <v-flex sm6 style="display: flex; align-items: center" xs12>
          <h3 class="title">Top Close Reason</h3>
        </v-flex>
        <v-flex class="text-sm-right text-xs-right" sm6 xs12>
          <v-btn color="primary" dark outline @click="handleExportXlsx">
            <em class="fas fa-file-export" />&nbsp;{{ $t('export') }}
          </v-btn>
        </v-flex>
      </v-layout>

      <date-filter
        v-model="selectedDate"
        :default-filter="'last_7_days'"
        @changeDate="handleFilterDate"
      />

      <template v-if="rawData">
        <div class="mt-5 mb-4">
          <ReasonItems :items="rawData.close_reason_level_1" level="1" />
        </div>
        <div class="mb-4">
          <ReasonItems :items="rawData.close_reason_level_2" level="2" />
        </div>
        <div>
          <ReasonItems :items="rawData.close_reason_level_3" level="3" />
        </div>
      </template>
    </v-container>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import ntApi from '@/api/nt.js'
import { mapGetters } from 'vuex'
import DateFilter from '@/components/view/dashboard/DateFilter.vue'
import ReasonItems from './ReasonItems.vue'
import * as XLSX from 'xlsx'

export default {
  name: 'TopCloseReason',
  components: {
    DateFilter,
    ReasonItems
  },
  data() {
    return {
      rawData: null,
      selectedDate: {
        start: dayjs().subtract(7, 'days').format('YYYY-MM-DD'),
        end: dayjs().format('YYYY-MM-DD')
      }
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  mounted() {
    this.handleFetchData()
  },
  methods: {
    async handleFetchData() {
      const vm = this
      try {
        const data = {
          page_id: vm.selectedBot.pageid,
          date_from: vm.selectedDate.start,
          date_to: vm.selectedDate.end
        }

        vm.$store.dispatch('loading')
        const response = await ntApi.getDashboardReason({
          config: {
            params: data
          }
        })
        vm.$store.dispatch('clear_loading')

        if (response && response.status === 200) {
          vm.rawData = response.data
        }
      } catch (error) {
        console.error(error)
      } finally {
        vm.$store.dispatch('clear_loading')
      }
    },
    handleFilterDate() {
      this.handleFetchData()
    },
    async handleExportXlsx() {
      try {
        const json = []
        const level1 = this.transformData(this.rawData.close_reason_level_1)
        const level2 = this.transformData(this.rawData.close_reason_level_2)
        const level3 = this.transformData(this.rawData.close_reason_level_3)
        json.push(['Top Close Reason'])
        json.push([
          `${dayjs(this.selectedDate.start).format('DD/MM/YYYY')} to ${dayjs(
            this.selectedDate.end
          ).format('DD/MM/YYYY')}`
        ])
        json.push([])
        json.push(['Close Reason Level 1'])
        json.push(['หัวข้อ', 'จำนวน', 'เปอร์เซ็นต์'])
        level1.map((data) => json.push(data))
        json.push([])
        json.push(['Close Reason Level 2'])
        json.push(['หัวข้อ', 'จำนวน', 'เปอร์เซ็นต์'])
        level2.map((data) => json.push(data))
        json.push([])
        json.push(['Close Reason Level 3'])
        json.push(['หัวข้อ', 'จำนวน', 'เปอร์เซ็นต์'])
        level3.map((data) => json.push(data))
        await this.generateExcel(json).save('top-close-reason')
      } catch (error) {
        console.error(error)
      }
    },
    transformData(data) {
      return data.length > 0
        ? data.map((item) => [item.reason || '-', item.count || 0, `${item.percent || 0}%`])
        : []
    },
    generateExcel(json) {
      function ExcelGenerator() {
        let _dataWS = XLSX.utils.aoa_to_sheet(json)

        this.setWorksheetProperty = (key, value) => {
          _dataWS[key] = value
          return this
        }

        this.save = (fileName) =>
          new Promise((resolve, reject) => {
            try {
              const wb = XLSX.utils.book_new()
              XLSX.utils.book_append_sheet(wb, _dataWS)
              XLSX.writeFile(wb, `${fileName}.xlsx`)
              resolve()
            } catch (error) {
              reject('Error: Generate excel failed')
            }
          })
      }

      return new ExcelGenerator()
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/customize/nt/Reason/index.vue